/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import {
  useRouteMatch,
  Switch,
  Route,
} from 'react-router-dom';
import { useSelector } from 'react-redux';

import OnboardingProcessing from '../Onboarding/OnboardingProcessing';
import OnboardingCreateEdit from './OnboardingCreateEdit';
import { useTranslation } from 'react-i18next';

const OnboardingRouting = ({ userId, theme }) => {
  const { url } = useRouteMatch();
  const { i18n } = useTranslation('');

  const { onbording } = useSelector((state) => state.accountReducer);

  const language = i18n.languages?.length ? i18n.languages[0] : 'en';
  let currentLang = ['en', 'sw'].includes(language) ? language : 'en';
  currentLang = useMemo(() => currentLang === 'sw' ? 'sv' : currentLang, [currentLang]);

  return (
    <Switch>
      <Route path={`${url}/edit/:onboardingId/`}>
        <OnboardingCreateEdit theme={theme} currentLang={currentLang} />
      </Route>
      <Route path={`${url}/processing`}>
        <OnboardingProcessing
          userId={userId}
          meeningId={onbording?.id}
          status={onbording?.status}
          url={url}
        />
      </Route>
    </Switch>
  );
};

export default OnboardingRouting;

OnboardingRouting.propTypes = {
  userId: PropTypes.string,
  theme: PropTypes.string,
};
